// (A) 중립 Alert API — antd 미접촉. (B) PlainAlert 에 위임(순수 시각, 인라인 아이콘).
import type { CSSProperties, ReactNode } from 'react'
import { PlainAlert } from '../_impl/PlainAlert'

export interface OmwAlertProps {
  /** 실측: EMLPreview 가 error/warning 알림 박스로 사용(message+description). */
  type?: 'success' | 'info' | 'warning' | 'error'
  message: ReactNode
  description?: ReactNode
  showIcon?: boolean
  className?: string
  style?: CSSProperties
}

export function OmwAlert(props: OmwAlertProps) {
  return <PlainAlert {...props} />
}
